/**
 * Sélecteur d'analyse, à l'intérieur de l'onglet « Analyses ».
 *
 * Le choix vit dans la query string (`?a=`), à côté de la période : passer
 * d'une analyse à l'autre ne réinitialise rien, et l'URL reste partageable.
 *
 * Une seule analyse est chargée à la fois. Les cinq requêtes sont lourdes —
 * cohortes, sessions, médianes par morceau — et les lancer toutes pour n'en
 * regarder qu'une gaspillerait des secondes de base à chaque visite.
 */

import { useSearchParams } from 'react-router-dom';

export const ANALYSES = [
  { id: 'cohorts', label: 'Cohortes' },
  { id: 'progression', label: 'Progression' },
  { id: 'completion', label: 'Complétion' },
  { id: 'churn', label: 'Abandons' },
  { id: 'features', label: 'Options & rétention' },
] as const;

export type AnalysisId = (typeof ANALYSES)[number]['id'];

export function useSelectedAnalysis(): [AnalysisId, (id: AnalysisId) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get('a');
  const current = ANALYSES.some((item) => item.id === raw) ? (raw as AnalysisId) : 'cohorts';

  const select = (id: AnalysisId) => {
    const next = new URLSearchParams(searchParams);
    next.set('a', id);
    setSearchParams(next, { replace: true });
  };

  return [current, select];
}

export function AnalysisNav() {
  const [current, select] = useSelectedAnalysis();

  return (
    <div className="preset-group analysis-nav" role="group" aria-label="Analyse">
      {ANALYSES.map((item) => (
        <button
          key={item.id}
          type="button"
          className="preset"
          aria-pressed={current === item.id}
          onClick={() => select(item.id)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
